// import external dependencies

import "jquery"
import AOS from 'aos'

// Import everything from autoload
import "./autoload/_bootstrap"
import "./modules/_navbar"
import "./modules/_smiles-slider"
import sliderSmiles from "./modules/_smiles-slider"
import playOnClick from "./modules/_play-video"

sliderSmiles();

//Smooth scroll after switching to another page
let target = window.location.hash;
	target = target.replace('#', '');

window.location.hash = "";

$(window).load(function() {
	if (target) {
		$('html, body').animate({
			scrollTop: $("#" + target).offset().top - 170,
		}, 500);
	}
});

jQuery(document).ready(() => {
	const headerTag = $('header').height();
	//replace h2 html with span + text
	const headerEl = $( ".interior .entry-content > h2:first-child" );
	const elText = headerEl.html();

	headerEl.html( '<span>' + elText + '</span>' );

	//Smooth Scroll Start
	$('a[href*="#"]')
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function (event) {
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				let target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

				if (target.length) {
					event.preventDefault();
					$(this).siblings().removeClass('active');
					$(this).addClass('active');
					$('html, body').animate({
						scrollTop: target.offset().top - headerTag,
					}, 500);
				}
			}
		});

	//aos init
	AOS.init({
		duration: 1200,
	})

	if ($('.img-placeholder').length) {
	playOnClick();
	}

	//Remove widget with Iframe on Testimonials page
	$('.entry-content').hasClass('testimonials') ? $('.custom-html-widget.reviews').parent().remove() : '';
});



// WEBPACK FOOTER //
// ./scripts/main.js